// /** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import styled from 'styled-components';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

export const Wrapper = styled(OverlayScrollbarsComponent)`
  ${tw`h-full w-full`}

  .os-scrollbar {
    --os-size: 20px;
    --os-padding-perpendicular: 7px;
    --os-padding-axis: 7px;
  }

  .os-scrollbar-handle {
    --os-handle-bg: ${({ $theme, $colorTheme }) => $theme?.get(`ui.scrollbar.${$colorTheme || 'light'}.enable`)};
    --os-handle-bg-hover: ${({ $theme, $colorTheme }) => $theme?.get(`ui.scrollbar.${$colorTheme || 'light'}.hover`)};
    --os-handle-bg-active: ${({ $theme, $colorTheme }) => $theme?.get(`ui.scrollbar.${$colorTheme || 'light'}.pressed`)};
  }
`;
